











import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import BaseComponent from './Base';

const ui = namespace('ui');

@Component
export default class NavMobileMenu extends BaseComponent {
    @ui.State('menuToggled') protected readonly isOpened: boolean;
    @ui.Mutation('toggleMenu') protected toggle: () => void;

    protected hideToggle() {
        this.toggle();
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavMobileMenu.vue